<script setup lang="ts">
// Use header animation for show/hide behavior, but always keep primary variant
const { transform, forceFinalVariant } = useHeaderAnimation({
	headerHeightInPx: 80,
	variants: ['primary', 'primary']
});
</script>

<template>
	<div class="min-h-screen">
		<PortalHeader
			variant="primary"
			:transform="transform"
			class="fixed z-50 h-[60px] lg:h-20"
			@nav-option-being-shown="forceFinalVariant = true"
			@nav-option-closed="forceFinalVariant = false"
		/>

		<main class="box-border size-full pt-20">
			<slot />
		</main>

		<Container class="bg-primary-light-4 py-0">
			<NavigationSectionNavigation />
		</Container>
		<Container class="bg-primary py-0">
			<PortalFooter />
		</Container>
	</div>
</template>
